import { FETCH_USER_SUCCESS } from "../types";

export default () => ({
  type: FETCH_USER_SUCCESS,
  payload: null,
});
